import { marked } from 'marked'
import getImageSrc from '@/util/getImageSrc'

export default {
  props: {
    trial: {
      type: Object,
      default: () => {}
    },
    imageCache: {
      type: Object,
      default: () => {}
    },
    step: {
      type: Number,
      default: 0
    },
    isPractice: {
      type: Boolean,
      default: false
    },
    handleTrialResponse: {
      type: Function,
      default() {
        return function () {}
      }
    }
  },
  computed: {
    trialData() {
      return this.trial?.component_data
    },
    isFirst() {
      return this.step === 0
    },
    header() {
      return this.trialData?.header
    },
    footer() {
      return this.trialData?.footer
    },
    body() {
      return this.trialData?.body
    }
  },
  methods: {
    getImageUrl(url) {
      const fullUrl = `${this.$store.state.exam.base_media_url}/${url}`
      return getImageSrc(fullUrl, this.imageCache)
    },
    renderMarkdown(val) {
      return marked(val.replace(/^[•*]\s?/gm, '* '))
    }
  }
}
